import { render, staticRenderFns } from "./Flatpickr.vue?vue&type=template&id=1181b7f4&"
import script from "./Flatpickr.vue?vue&type=script&lang=js&"
export * from "./Flatpickr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports